import { render, staticRenderFns } from "./AdminCreateAbsence.vue?vue&type=template&id=2bfdc81a&scoped=true"
import script from "./AdminCreateAbsence.vue?vue&type=script&lang=js"
export * from "./AdminCreateAbsence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdc81a",
  null
  
)

export default component.exports